var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.12 5.35951L12.429 5.05055C12.9409 4.53865 13.7708 4.53865 14.2827 5.05055C14.7946 5.56245 14.7946 6.39241 14.2827 6.90431L13.9738 7.21327M12.12 5.35951C12.12 5.35951 12.1586 6.01605 12.7379 6.59535C13.3172 7.17465 13.9738 7.21327 13.9738 7.21327M12.12 5.35951L9.27961 8.19993C9.08722 8.39231 8.99103 8.48851 8.9083 8.59457C8.81071 8.71969 8.72705 8.85506 8.65878 8.9983C8.60091 9.11973 8.55789 9.24878 8.47185 9.5069L8.19639 10.3333L8.10727 10.6007M13.9738 7.21327L11.1334 10.0537C10.941 10.2461 10.8448 10.3423 10.7387 10.425C10.6136 10.5226 10.4782 10.6062 10.335 10.6745C10.2136 10.7324 10.0845 10.7754 9.82639 10.8614L9 11.1369L8.73264 11.226M8.73264 11.226L8.46528 11.3151C8.33826 11.3575 8.19822 11.3244 8.10354 11.2297C8.00887 11.1351 7.97581 10.995 8.01815 10.868L8.10727 10.6007M8.73264 11.226L8.10727 10.6007",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 8.66663H6.99992",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 6H9.66659",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 11.3334H6.33325",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.219 2.11442C12.4379 1.33337 11.1808 1.33337 8.66667 1.33337H7.33333C4.81918 1.33337 3.5621 1.33337 2.78105 2.11442C2 2.89547 2 4.15255 2 6.66671V9.33337C2 11.8475 2 13.1046 2.78105 13.8857C3.5621 14.6667 4.81918 14.6667 7.33333 14.6667H8.66667C11.1808 14.6667 12.4379 14.6667 13.219 13.8857C13.8477 13.2569 13.9703 12.3198 13.9942 10.6667",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentAdd);
export default __webpack_public_path__ + "static/media/documentAdd.b85d7dc557c0cfed77a486326004440b.svg";
export { ForwardRef as ReactComponent };